import {ReactComponent as Icon} from '@image/icon_admin.svg';

const IconAdmin = () => {
    return   <Icon />;
};

export default IconAdmin;